export default __webpack_public_path__ + "static/media/user.8ef56f21.webp";